import { documentsService } from "../../../services/documentsService";

export const downloadFile = async (parentType, parentId, id, fileName) => {
    const blob = await documentsService.attachment(parentType, parentId, id, fileName);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export const printFile = async (parentType, parentId, id, fileName) => {
    const blob = await documentsService.attachment(parentType, parentId, id, fileName);
    const url = URL.createObjectURL(blob);
    const win = window.open(url);
    win?.print();
}
